import {AppThemeEnum} from '../../types/theme';
import {AnyAction} from 'redux';
import {APP_THEME_SET_THEME} from '../../reducer/apptheme';

export const setAppTheme = (payload: AppThemeEnum): AnyAction => ({
  type: APP_THEME_SET_THEME,
  payload
});
